import styled, { css } from 'styled-components/macro';
import { getDSColor } from 'utils';
import { getAvatarSettings } from './avatar.constants';
import { StyledAvatarGroupProps, StyledAvatarProps } from './avatar.types';

export const StyledAvatar = styled.div<StyledAvatarProps>`
  ${({ theme, $size, $color, $hasChildren, $hasSrc }) => {
    const { size, radius } = getAvatarSettings(theme)[$size];

    return css`
      box-sizing: border-box;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      width: ${size}px;
      height: ${size}px;
      border-radius: ${radius};
      overflow: hidden;
      user-select: none;

      svg {
        max-width: 100%;
      }

      ${!$hasChildren
        ? css`
            color: ${theme.semantic.avatar.placeholder};
            background: ${theme.semantic.avatar.bg};
          `
        : css`
            color: ${theme.semantic.text.onColored};
            background: ${$hasSrc
              ? 'transparent'
              : css`
                  linear-gradient(
                    180deg,
                    ${theme.colors[$color ?? 'primary'][400]} 0%,
                    ${theme.colors[$color ?? 'primary'][600]} 100%
                  )
                `};
          `}

      span {
        font-weight: normal;
      }

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    `;
  }}
`;

export const StyledAvatarGroup = styled.div<StyledAvatarGroupProps>`
  ${({ theme, $size, $avatarBorderColor }) => {
    const { groupOverlay, groupAvatarBorder } = getAvatarSettings(theme)[$size];

    return css`
      display: flex;
      align-items: center;

      & > * {
        border: ${groupAvatarBorder}px solid
          ${$avatarBorderColor === 'white'
            ? theme.semantic.avatar.borderGroup
            : getDSColor(theme, $avatarBorderColor)};

        &:not(:first-child) {
          margin-left: -${groupOverlay};
        }
      }
    `;
  }}
`;
